// extracted by mini-css-extract-plugin
module.exports = {"Thank":"Thank_Thank__qMGCb","Desc":"Thank_Desc__2J0Zu"};